import { render } from "./RecepcionExpress.vue?vue&type=template&id=949ddfba&scoped=true"
import script from "./RecepcionExpress.vue?vue&type=script&lang=js"
export * from "./RecepcionExpress.vue?vue&type=script&lang=js"

import "./RecepcionExpress.vue?vue&type=style&index=0&id=949ddfba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949ddfba"]])

export default __exports__